import axiosInstance from 'Utils/axiosInstance';
import { mapDtoToAutomation } from 'Utils/mappers';

export async function getAutomations(params = {}) {
    const response = await axiosInstance.get('/rules', { params });

    if (!response?.data) return {};

    return {
        ...response.data,
        items: response.data.items.map(mapDtoToAutomation),
    };
}

export async function deleteAutomation(id) {
    await axiosInstance.delete(`/rules/${id}`);
}

export async function createAutomation({
    name,
    conditions,
    providers_connections_products_ids,
    is_conditions_advanced,
    actions,
}) {
    const automation = {
        providers_connections_products_ids,
        type: 'transaction_modify',
        name,
        conditions,
        is_conditions_advanced,
        actions,
        is_enabled: true,
    };

    const response = await axiosInstance.post('/rules', automation);

    if (!response?.data) return null;

    return mapDtoToAutomation(response.data);
}

export async function editAutomation({
    id,
    name,
    conditions,
    providers_connections_products_ids,
    is_conditions_advanced,
    actions,
    is_enabled = true,
}) {
    const automation = {
        providers_connections_products_ids,
        type: 'transaction_modify',
        name,
        conditions,
        is_conditions_advanced,
        is_enabled,
        actions,
    };

    const response = await axiosInstance.put(`/rules/${id}`, automation);

    if (!response?.data) return null;

    return mapDtoToAutomation(response.data);
}

export async function getAutomationRetrospectPreview(id) {
    const response = await axiosInstance.post(`/rules/${id}/preview`);
    return response?.data;
}

export async function consolidateAutomationRetrospect(id) {
    await axiosInstance.post(`/rules/${id}/retrospect`);
}

export async function consolidateAutomationRetrospectAll() {
    await axiosInstance.post('/rules/retrospect');
}

export async function mergeContacts(contactId, contactIdsToMerge) {
    const response = await axiosInstance.post(`/contacts/${contactId}/merge`, {
        contacts_merged_ids: contactIdsToMerge,
    });

    if (!response?.data) return null;

    return response.data;
}
